import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import MobileView from '@orgmap/views/MobileView.vue';
import OrgchartToolbar from './OrgchartToolbar.vue';

@Component({
    components: {
        MobileView,
        OrgchartToolbar,
    }
})
export default class OrgchartView extends Vue {
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //
    @Prop({ type: String }) type!: string;

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //
    currentUser!: any;
    userList!: any;
    user: any = {};

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: M E T H O D S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //
    selectItem(item: any) {
        this.user = item;
    }
}
